(function () {
  function bindEmbed(frame) {
    if (frame.dataset.lpVideoReady) return;
    frame.dataset.lpVideoReady = '1';
    var btn = frame.querySelector('[data-lp-video-play]');
    if (!btn) return;
    var type = frame.dataset.videoType;
    var id = frame.dataset.videoId;
    if (!type || !id) return;
    btn.addEventListener('click', function () {
      var src =
        type === 'youtube'
          ? 'https://www.youtube.com/embed/' +
            id +
            '?autoplay=1&rel=0&modestbranding=1'
          : 'https://player.vimeo.com/video/' + id + '?autoplay=1';
      var iframe = document.createElement('iframe');
      iframe.className = 'lp-Video_Iframe';
      iframe.setAttribute('src', src);
      iframe.setAttribute('title', frame.dataset.videoTitle || 'Video');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      );
      var poster = frame.querySelector('.lp-Video_Poster');
      if (poster) poster.remove();
      btn.remove();
      frame.appendChild(iframe);
    });
  }

  function bindFile(frame) {
    if (frame.dataset.lpVideoFileReady) return;
    frame.dataset.lpVideoFileReady = '1';
    var btn = frame.querySelector('[data-lp-video-play]');
    var video = frame.querySelector('video');
    if (!btn || !video) return;

    /* Manual play via button */
    btn.addEventListener('click', function () {
      var poster = frame.querySelector('.lp-Video_Poster');
      if (poster) poster.remove();
      btn.remove();
      video.muted = false;
      video.controls = true;
      video.focus();
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    });

    /* Mobile autoplay on scroll (muted, loops) */
    if (frame.closest('.lp-Video_Video--mobileOnly')) {
      video.muted = true;
      video.loop = true;
      video.setAttribute('playsinline', '');

      /* Create mute/unmute toggle button */
      var muteBtn = document.createElement('button');
      muteBtn.type = 'button';
      muteBtn.className = 'lp-Video_Mute';
      muteBtn.setAttribute('aria-label', 'Unmute video');
      muteBtn.innerHTML =
        '<svg class="lp-Video_MuteIcon lp-Video_MuteIcon--muted" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>' +
        '<svg class="lp-Video_MuteIcon lp-Video_MuteIcon--unmuted" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>';
      muteBtn.style.display = 'none';
      frame.appendChild(muteBtn);

      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        frame.classList.toggle('is-unmuted', !video.muted);
        muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var poster = frame.querySelector('.lp-Video_Poster');
              if (poster) poster.style.display = 'none';
              if (btn) btn.style.display = 'none';
              muteBtn.style.display = '';
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.5 }
      );
      observer.observe(frame);
    }
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-lp-video-frame]').forEach(bindEmbed);
    scope.querySelectorAll('[data-lp-video-file]').forEach(bindFile);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) init(e.target);
  });
})();
